import { render } from "./TariffBlock.vue?vue&type=template&id=e8a09802"
import script from "./TariffBlock.vue?vue&type=script&lang=js"
export * from "./TariffBlock.vue?vue&type=script&lang=js"

import "./TariffBlock.vue?vue&type=style&index=0&id=e8a09802&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__